import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ComponentsModule } from '@nx-customer-apps/components';

@Component({
    selector: 'vp-chip-success',
    templateUrl: './chip-success.component.html',
    styleUrls: ['./chip-success.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ComponentsModule]
})
export class ChipSuccessComponent {}
